// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const HeaderIconText = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.header.headerIconText"
        description="Header icon text."
        defaultMessage="Icon"
    />
);
HeaderIconText.displayName = "HeaderIconText";

export const HeaderNameText = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.header.headerNameText"
        description="Header name text."
        defaultMessage="Name"
    />
);
HeaderNameText.displayName = "HeaderNameText";

export const HeaderDateModifiedText = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.header.headerDateModifiedText"
        description="Header date modified text."
        defaultMessage="Date Modified"
    />
);
HeaderDateModifiedText.displayName = "HeaderDateModifiedText";

export const HeaderAdsAvailabilityText = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.header.headerAdsAvailabilityText"
        description="Header ads availability text."
        defaultMessage="Ads"
    />
);
HeaderAdsAvailabilityText.displayName = "HeaderAdsAvailabilityText";

export const HeaderStatusText = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.header.headerStatusText"
        description="Header status text."
        defaultMessage="Status"
    />
);
HeaderStatusText.displayName = "HeaderStatusText";

export const HeaderVisibilityText = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.header.headerVisibilityText"
        description="Header visibility text."
        defaultMessage="Visibility"
    />
);
HeaderVisibilityText.displayName = "HeaderVisibilityText";

export const HeaderAdsAvailabilityTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.header.headerAdsAvailabilityTooltip"
        description="Header ads availability tooltip."
        defaultMessage="Lenses must satisfy Lens Activation Time requirements in order to be run in an ad campaign."
    />
);
HeaderAdsAvailabilityTooltip.displayName = "HeaderAdsAvailabilityTooltip";

export const CreateFolder = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.header.createFolder"
        description="Create folder."
        defaultMessage="Create Folder"
    />
);
CreateFolder.displayName = "CreateFolder";
